module.exports = __webpack_public_path__ + "static/media/admin.a1a14def.png";